import { useNavigate } from "react-router-dom";

import { useStoredUrlParams } from "./useUrlParamsToSessionStorage";

export const useNavigates = () => {
  const navigate = useNavigate();
  const storedParams = useStoredUrlParams();

  const navigateConsultationDetail = (id: string) => {
    navigate(`/consultations/${id}`);
  };

  const navigateOnlineConsultation = (id?: string) => {
    navigate(`/onlineConsultation/${id}`);
  };

  const navigateHome = (done?: string) => {
    navigate(`${done ? done : "/"}`);
  };

  const navigateUploadInsuranceCards = () => {
    navigate("/uploadInsuranceCards");
  };

  const navigateAddPaymentMethod = () => {
    navigate("/addPaymentMethod");
  };

  const navigateBack = () => {
    navigate(-1);
  };

  const navigateMe = (type?: string) => {
    navigate(`/me?type=${type}`);
  };

  const navigateSignUpFinish = () => {
    navigate("/signUpFinish");
  };

  const navigateUserRegister = () => {
    navigate("/userRegister");
  };

  const navigateConfirmSignUp = (email: string, password: string) => {
    navigate("/confirmSignUp", { state: { email: email, password: password } });
  };

  const navigateUsageHistory = () => {
    navigate("/usageHistory");
  };

  const navigateLogin = () => {
    navigate("/");
  };

  const navigateReEntryRoom = (id: string) => {
    navigate(`/reEntryRoom/${id}`);
  };

  // URLパラメータを構築するヘルパー関数
  const buildUrlWithStoredParams = (
    baseUrl: string,
    additionalParams: Record<string, string | boolean> = {}
  ) => {
    const url = new URL(baseUrl, window.location.origin);

    // 追加パラメータを設定
    Object.entries(additionalParams).forEach(([key, value]) => {
      url.searchParams.set(key, String(value));
    });

    // セッションストレージからcouponとtypeを取得して追加
    if (storedParams?.coupon) {
      url.searchParams.set("coupon", storedParams.coupon);
    }
    if (storedParams?.type) {
      url.searchParams.set("type", storedParams.type);
    }

    return url.pathname + url.search;
  };

  const navigateReConsultation = (id: string, step: number | string) => {
    const url = buildUrlWithStoredParams(`/reConsultations/${id}`, {
      step: String(step),
    });
    navigate(url);
  };

  const navigateConsultationsNew = (
    step: number | string,
    isUpdate: boolean = false
  ) => {
    const url = buildUrlWithStoredParams("/consultations", {
      step: String(step),
      isUpdate,
    });
    navigate(url);
  };

  const navigateConsultationsConfirm = (isUpdate: boolean = false) => {
    const url = buildUrlWithStoredParams("/consultations", {
      step: "confirm",
      isUpdate,
    });
    navigate(url);
  };

  return {
    navigateHome,
    navigateBack,
    navigateConsultationDetail,
    navigateReConsultation,
    navigateOnlineConsultation,
    navigateUploadInsuranceCards,
    navigateAddPaymentMethod,
    navigateMe,
    navigateSignUpFinish,
    navigateUserRegister,
    navigateConfirmSignUp,
    navigateLogin,
    navigateUsageHistory,
    navigateReEntryRoom,
    navigateConsultationsNew,
    navigateConsultationsConfirm,
  };
};
